import {FC} from 'react'

const OnlinePulse: FC = () => {
  return (
    <>
      <span className='pulse pulse-success bg-state-body'>
        <div
          className='bg-success w-10px h-10px mt-1 me-3'
          style={{borderRadius: '50px 50px 50px 50px'}}
        >
          &nbsp;
        </div>
        <span className='pulse-ring' style={{left: '-5px', top: '-12px'}} />
      </span>
    </>
  )
}

export {OnlinePulse}
